import RelationshipProof from './RelationshipProof';

export default RelationshipProof;
